type KeyString = {
  [key: string]: string
}

export const CUSTOM_FORM_KIND_NAME: KeyString = {
  SHORT_TEXT: 'Resposta curta',
  LONG_TEXT: 'Parágrafo',
  INTEGER: 'Número inteiro',
  DECIMAL: 'Número decimal',
  EMAIL: 'Email',
  DOCUMENT: 'Documentos',
  CEP: 'CEP',
  MULTIPLE_SELECTION_BOX: 'Caixas de seleção',
  SINGLE_SELECTION_BOX: 'Escolha única',
  SINGLE_SELECTION_LIST: 'Lista suspensa',
  SINGLE_FILE_UPLOAD: 'Subir arquivo',
  MULTIPLE_FILE_UPLOAD: 'Múltiplos arquivos',
  ENTITY: 'Registro da base de dados',
  NPS: 'NPS',
  DATE: 'Data',
  TIME: 'Horário',
  PHONE: 'Telefone',
}
